import React from "react";
import Tshirt from "../Component/Tshirt";

const TShirtPage = () => {
  return (
    <>
      <Tshirt /> //Used the Tshirt component here
    </>
  );
};

export default TShirtPage;
